import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import AboutView from '@/views/AboutView.vue';
import ContactView from '@/views/ContactView.vue';
import AIAgentView from '@/views/AIAgentView.vue';
import GPTsView from '@/views/GPTsView.vue';
import GPTView from '@/views/GPTView.vue';
import LabsView from '@/views/LabsView.vue';
import LabView from '@/views/LabView.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import site, { applyMeta } from '@/seo';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/about-us',
    name: 'About',
    component: AboutView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView
  },
  {
    path: '/ai-agents',
    name: 'AI Agents',
    component: AIAgentView
  },
  {
    path: '/ai-agents/custom-gpts',
    name: 'Custom GPTs',
    component: GPTsView
  },
  {
    path: '/ai-agents/custom-gpts/:permalink',
    name: 'CustomGpt',
    component: GPTView
  },
  {
    path: '/labs',
    name: 'Labs',
    component: LabsView
  },
  {
    path: '/labs/:permalink',
    name: 'Lab',
    component: LabView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundView
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  }
});

// Detail pages refine this once their content arrives.
router.afterEach((to) => {
  applyMeta({
    path: to.path,
    title: to.name === 'NotFound' ? `Page not found — ${site.name}` : undefined,
  });
});

export default router;
